import { LocationNumbersService } from "../../../services"

enum NumberType {
  LOCAL = 'local',
  MOBILE = 'mobile',
  TOLL_FREE = 'toll-free',
}

enum BundleStatus {
  TWILIO_APPROVED = 'twilio-approved',
  DRAFT = 'draft',
}

const fetchAllBundles = async function({ commit }, payload) {
  try {
    const { data } = await LocationNumbersService.getAllRegulatoryBundles(
      payload
    )

    const {bundle, regulations} = data

    const countryCode = payload.countryCode || 'GB'

    const combinedRegulatoryBundles = bundle.reduce((acc, bundle) => {
      if (bundle.status === BundleStatus.TWILIO_APPROVED) {
        const regulation = regulations.find(regulation => regulation.sid === bundle.regulationSid);
        if (regulation && regulation.isoCountry === countryCode) {
          bundle.friendlyName = regulation.friendlyName;
          if (regulation.numberType === NumberType.LOCAL) {
            acc.local.push(bundle);
          } else if (regulation.numberType === NumberType.MOBILE) {
            acc.mobile.push(bundle);
          } else if (regulation.numberType === NumberType.TOLL_FREE) {
            acc.tollFree.push(bundle);
          }
        }
      }
      return acc;
    }, { local: [], mobile: [], tollFree: [] });


    commit('setRCBundleList', combinedRegulatoryBundles)

    return data
  } catch (error) {
    throw error
  }
}

export default fetchAllBundles
